<template>
  <section class="agency">
    <h2>
      {{ heading }}
    </h2>
    <div class="label">
      {{ business.label }}
    </div>
    <div class="address">
      {{ business.address }}<br>
      {{ business.city.postal_code }}
      {{ business.city.label }}
    </div>
    <br>
    <basic-prompt>
      <template v-slot:visible>
        <div class="clickable-txt">
          <svg>
            <use xlink:href="#icon-clock"></use>
          </svg> voir les horaires
        </div>
      </template>
      <template v-slot:prompt>
        {{ weekdaysTxt }}<br>
        {{ weekendsTxt }}
      </template>
    </basic-prompt>
    <a
      @click="analytics()"
      type="button"
    >
      <basic-prompt
        :replace="true"
      >
        <template v-slot:visible>
          <div
            class="clickable-txt"
          >
            <svg>
              <use xlink:href="#icon-phone"></use>
            </svg> voir le téléphone
          </div>
        </template>
        <template v-slot:prompt>
          <div class="visible-phone">
            <svg>
              <use xlink:href="#icon-phone"></use>
            </svg>
            tél&nbsp;:&nbsp;{{ business.phone }}<br>
          </div>
        </template>
      </basic-prompt>
    </a>

    <div
      class="clickable-txt -lightbox"
      @click="lightBoxOpen = true"
    >
      <svg>
        <use xlink:href="#icon-email"></use>
      </svg> contacter par email
    </div>

    <light-box
      :visible="lightBoxOpen"
      @close="clicked()"
    >
      <div class="lightbox-wrapper">
        <contact-top
          v-if="!contact"
          :title=" $t('contact.title')"
          :copy=" $t('contact.copy')"
        />
        <div v-if="contactMode || contactMode === null">
          <contact-particulier
            class="lightbox-content"
            :popin-mode="true"
            :business="business"
            v-if="!contact && (contactMode === 1 || contactMode === null)"
          />
          <contact-professionel
            class="lightbox-content"
            :popin-mode="true"
            :business="business"
            v-if="!contact && contactMode === 2"
          />
        </div>
        <div
          v-if="contact "
          class="text-popin"
        >
          {{ $t('contact.success') }}
        </div>
      </div>
    </light-box>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import BasicPrompt from '../shared/BasicPrompt'
import businessHours from '../shared/mixins/businessHours'
import LightBox from '../shared/LightBox'
import ContactTop from '../Contact/ContactTop'
import ContactParticulier from '../Contact/ContactParticulier'
import vehicleCards from '../shared/mixins/vehicleCards'
import ContactProfessionel from '../Contact/ContactProfessionel'

export default {
  mixins: [businessHours, vehicleCards],
  components: {
    BasicPrompt,
    LightBox,
    ContactParticulier,
    ContactTop,
    ContactProfessionel,

  },
  data() {
    return {
      lightBoxOpen: false,
      contact: this.$store.state.contact.isSubmitted,
    }
  },
  watch: {
    contactSubmitted: {
      handler(val) {
        this.contact = val
      },
      immediate: true,
    },
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    business: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      isSubmitted: (state) => state.contact.isSubmitted,

    }),
    contactSubmitted() {
      return this.$store.state.contact.isSubmitted
    },
    contactMode() {
      return this.$store.state.contact.contactMode
    },

  },
  methods: {
    clicked() {
      this.lightBoxOpen = false
      this.contact = false
    },
    analytics() {
      if (!window.dataLayer) {
        return
      }
      const event = 'CallPhone'
      const availabilityStatus = this.vehicleCardsSelectedVehicleIsAvailable > 0
      const contactMethod = 'call'
      const loginStatus = this.vehicleCardsProfileRequested ? this.vehicleCardsUserIsLogged : 'N/A'
      const page = window.location.href
      const pageCategory = ''
      const pageTitle = document.querySelector('head title')?.text
      /* eslint-disable-next-line camelcase */
      const VehicleModel = this.storeVehicle?.semi_clair

      const payload = {
        event,
        availabilityStatus,
        contactMethod,
        loginStatus,
        page,
        pageCategory,
        pageTitle,
        VehicleModel,
      }
      window.dataLayer.push(payload)
    },
  },
}
</script>
<style lang="scss" scoped>

section {
  color: $c-boulder;

  @include teq-breakpoint($large) {
    max-width: 225px;
  }
}

h2 {
  font-family: $f-graphie-bold;
  font-weight: 600;
  margin: 0 0 15px;
  text-align: left;
  text-transform: none;

  @include font-size(20px);
}

.label {
  @include font-size(14px);
}

svg {
  fill: black;
  height: 16px;
  margin: 0 7px 0 0;
  width: 16px;
}

.address {
  @include font-size(14px);
}

.clickable-txt,
.visible-phone {
  align-items: center;
  color: black;
  cursor: pointer;
  display: flex;
  margin: 0 0 15px;
  pointer-events: none;
  text-decoration: underline;

  @include font-size(12px);

  &.-lightbox {
    pointer-events: auto;
  }
}

.visible-phone {
  text-decoration: none;
}

.light-box ::v-deep {
  max-width: none;
}

.lightbox-wrapper {
  font-size: 1rem;
  max-height: 90vh;
  max-width: none;
  overflow: auto;
  padding: 20px 20px 20px;

  .lightbox-content {
    max-width: none;
  }
}

.text-popin {
  align-items: center;
  align-self: stretch;
  color: $c-nevada;
  display: flex;
  font-size: 1.6rem;
  margin-right: 20px;
}

</style>
